export default __webpack_public_path__ + "static/media/tree.46b02d7e.png";